import React, { useState, useRef, useEffect } from "react";

import $ from "jquery";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
import { CloseOutlined } from "@mui/icons-material";
import Paper from "@mui/material/Paper";
// import moment from "moment";
import { AxiosInstance } from "../../../../axios";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
import ViewIcon from "../BookModule/AdminSide/BookTabs/ViewIcon.png";
import ListInfo from "../BookModule/BookModule.module.css";
import DatePickerSample from "../../DatePicker";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { Search } from "@material-ui/icons";
import Loader from "../../Loader";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { ExportTableToPdf } from "../../../ReusuableComponent/ExportTableToPdf";
import toast from "react-hot-toast";
function BookPurchase(props) {
  const moment = require("moment-timezone");
  const [listData, setListData] = useState([]);
  const txtBSearch = useRef(null); //Search icon
  // List data load table
  let page = R_PER_PAGE;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }
  const location = useLocation();
  const {
    filPayment_mode,
    filPayment_status,
    fildelivery_mode,
    fildelivery_status,
    filter_search,
  } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [downloadCSV, setDownloadCSV] = useState([]);
  const [downloadPDF, setDownloadPDF] = useState([]);
  const [updateListData, setUpdateListData] = useState(listData);
  const [payment_mode, setpayment_mode] = useState([]);
  const [payment_status, setpayment_status] = useState([]);

  const [delivery_mode, setDelivery_mode] = useState([]);

  const [delivery_status, setDelivery_status] = useState([]);
  const [dupData, setDupData] = useState();

  const [updateChipData, setUpdateChipData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);
  useEffect(() => {
    if (location.state) {
      // Optionally do something here if needed
    }
  }, [location.state]);
  useEffect(() => {
    if (props.tabChange) {
      handleAllClear();
      props.setTabChange(false);
    }
  }, [props.tabChange]);
  useEffect(() => {
    if (filPayment_mode && filPayment_mode.length > 0) {
      setpayment_mode(filPayment_mode);
      filterPayment = filPayment_mode;
    } else {
      setpayment_mode(payment_mode);
      filterPayment = payment_mode;
    }
    if (filPayment_status && filPayment_status.length > 0) {
      setpayment_status(filPayment_status);
      filterStatus = filPayment_status;
    } else {
      setpayment_status(payment_status);
      filterStatus = payment_status;
    }
    if (fildelivery_mode && fildelivery_mode.length > 0) {
      setDelivery_mode(fildelivery_mode);
      filterDeliveryMode = fildelivery_mode;
    } else {
      setDelivery_mode(delivery_mode);
      filterDeliveryMode = delivery_mode;
    }
    if (fildelivery_status && fildelivery_status.length > 0) {
      setDelivery_status(fildelivery_status);
      filterDeliveryStatus = fildelivery_status;
    } else {
      setDelivery_status(delivery_status);
      filterDeliveryStatus = delivery_status;
    }
    if (filter_search && filter_search.length > 0) {
      filterSearch = [{ name: "" + filter_search, type: "search" }];
      setSearchTerm(filter_search);
    } else {
      if (searchTerm) {
        setSearchTerm(payment_mode);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, [
    filPayment_mode,
    filPayment_status,
    fildelivery_mode,
    fildelivery_status,
    filter_search,
  ]);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);

  let filterSearch = [];
  const filterRef_payment_mode = useRef(null);
  const filterRef_payment_status = useRef(null);
  const filterRef_delivery_mode = useRef(null);
  const filterRef_delivery_status = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_payment_mode.current &&
        !filterRef_payment_mode.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "payment_mode"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "payment_mode"
            );
            setpayment_mode(updatedAuthor);
          } else {
            setpayment_mode([]);
          }
          setIsOpen((prev) => ({ ...prev, payment_mode: false }));
        }
      }
      if (
        filterRef_payment_status.current &&
        !filterRef_payment_status.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "payment_status"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "payment_status"
            );
            setpayment_status(updatedCategory);
          } else {
            setpayment_status([]);
          }
          setIsOpen((prev) => ({ ...prev, payment_status: false }));
        }
      }
      if (
        filterRef_delivery_mode.current &&
        !filterRef_delivery_mode.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "delivery_mode"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "delivery_mode"
            );
            setDelivery_mode(updatedCategory);
          } else {
            setDelivery_mode([]);
          }
          setIsOpen((prev) => ({ ...prev, delivery_mode: false }));
        }
      }
      if (
        filterRef_delivery_status.current &&
        !filterRef_delivery_status.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "delivery_status"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "delivery_status"
            );
            setDelivery_status(updatedCategory);
          } else {
            setDelivery_status([]);
          }
          setIsOpen((prev) => ({ ...prev, delivery_status: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    updateChipData,
    payment_mode,
    payment_status,
    delivery_mode,
    delivery_status,
  ]);
  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  // useEffect(() => {
  //   loadChipdata();
  // }, []);

  function updateStateData() {
    filterPayment = payment_mode;
    filterDeliveryMode = delivery_mode;
    filterDeliveryStatus = delivery_status;
    filterStatus = payment_status;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  //sorting function

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    // setSortColumn(sortKey);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  // handle search function
  const handleSearch = (event) => {
    // console.log(event);
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };
  //-------end ------
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setpayment_mode([]);
    setDelivery_mode([]);
    setpayment_status([]);
    setDelivery_status([]);
    // loadListdata();
    setUpdateChipData([]);
  };

  function loadListdata() {
    let tempPaymentMode = [];
    let tempPaymentStatus = [];
    let tempDeliveryMode = [];
    let tempDeliveryStatus = [];

    payment_mode.map((obj) => {
      tempPaymentMode.push(obj.id);
    });
    payment_status.map((obj) => {
      tempPaymentStatus.push(obj.id);
    });
    delivery_mode.map((obj) => {
      tempDeliveryMode.push(obj.id);
    });
    delivery_status.map((obj) => {
      tempDeliveryStatus.push(parseInt(obj.id));
    });

    let statusFilter = {
      search: searchTerm.length > 0 ? searchTerm : "",
      user_id: userid,
      payment_mode: payment_mode.length > 0 ? Number(payment_mode[0].id) : "",
      payment_status:
        payment_status.length > 0 ? Number(payment_status[0].id) : "",
      delivery_mode:
        delivery_mode.length > 0 ? Number(delivery_mode[0].id) : "",
      // delivery_status: delivery_status.length > 0 ? Number(delivery_status[0].id) : ""
      delivery_status: delivery_status.length > 0 ? tempDeliveryStatus : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/book/purchase/list_by_student", statusFilter)
      .then((res) => {
        // console.log("editadasd ", res);
        if (res.data.status === true) {
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            purchase_id: item.purchase_id,
            item_count: item.item_count,
            purchase_date: `${moment(item.purchase_date).utc().format("DD/MM/YYYY hh:mm:ss a")}`,
            amount_paid: item.amount_paid,
            payment_mode:
              item.payment_mode === 1
                ? "Online"
                : item.payment_mode === 2
                ? "QR Cash"
                : item.payment_mode === 3
                ? "Free"
                : "Cash",
            transaction_status:
              item.transaction_status === 4 ? "Completed" : "Payment Pending",
            shipping_type:
              item.shipping_type === 1 ? "Courier Delivery" : "Branch Pickup",
            delivery_status_name: item.delivery_status_name,
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          setIsLoading(false);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  // total table data  with pages
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    // if (name === "pageCount") {
    setRowsPerPage(parseInt(value));
    setCurrentPage(1);
    setUpdateListData([]);
    // }
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  const handleNavPage = (puId, TranID) => {
    navigate("/AddToCart/PaymentSuccess/1", {
      state: {
        purchase_id: puId,
        order_id: TranID,
        PAYMENT_MODE: payment_mode,
        PAYMENT_STATUS: payment_status,
        DELIVERY_MODE: delivery_mode,
        DELIVERY_STATUS: delivery_status,
        SEACRHTERM: searchTerm,
      },
    });
  };
  const [isOpen, setIsOpen] = useState({
    payment_mode: false,
    payment_status: false,
    delivery_mode: false,
    delivery_status: false,
  });

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "payment_mode") {
      if (checked) {
        setpayment_mode([{ id: value, name: name, type: "payment_mode" }]);
      } else {
        setpayment_mode(payment_mode.filter((item) => item.id !== value));
      }
    } else if (typename === "payment_status") {
      if (checked) {
        setpayment_status([{ id: value, name: name, type: "payment_status" }]);
      } else {
        setpayment_status(payment_status.filter((item) => item.id !== value));
      }
    } else if (typename === "delivery_mode") {
      if (checked) {
        setDelivery_mode([{ id: value, name: name, type: "delivery_mode" }]);
      } else {
        setDelivery_mode(delivery_mode.filter((item) => item.id !== value));
      }
    } else if (typename === "delivery_status") {
      if (checked) {
        setDelivery_status([
          ...delivery_status,
          { id: value, name: name, type: "delivery_status" },
        ]);
      } else {
        setDelivery_status(delivery_status.filter((item) => item.id !== value));
      }
    }
  };
  const handleFilter = (e, boxName) => {
    if (boxName === "payment_mode") {
      setIsOpen((prevState) => ({
        type: false,
        payment_mode: !prevState.payment_mode,
      }));
      setpayment_mode(
        updateChipData.filter((ui) => ui.type === "payment_mode")
      );
    }
    if (boxName === "payment_status") {
      setIsOpen((prevState) => ({
        type: false,
        payment_status: !prevState.payment_status,
      }));
      setpayment_status(
        updateChipData.filter((ui) => ui.type === "payment_status")
      );
    }
    if (boxName === "delivery_mode") {
      setIsOpen((prevState) => ({
        type: false,
        delivery_mode: !prevState.delivery_mode,
      }));
      setDelivery_mode(
        updateChipData.filter((ui) => ui.type === "delivery_mode")
      );
    }

    if (boxName === "delivery_status") {
      setIsOpen((prevState) => ({
        type: false,
        branch_location_name: false,
        delivery_status: !prevState.delivery_status,
      }));
      setDelivery_status(
        updateChipData.filter((ui) => ui.type === "delivery_status")
      );
    }
  };
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "payment_mode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        payment_mode: false,
      });
    }
    if (name === "payment_status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        payment_status: false,
      });
    }
    if (name === "delivery_mode") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        delivery_mode: false,
      });
    }
    if (name === "delivery_status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        delivery_status: false,
      });
    }
  };
  let filterPayment = [];
  let filterDeliveryMode = [];
  let filterDeliveryStatus = [];
  let filterStatus = [];
  useEffect(() => {
    filterPayment = payment_mode;
  }, [payment_mode]);
  useEffect(() => {
    filterDeliveryMode = delivery_mode;
  }, [delivery_mode]);
  useEffect(() => {
    filterDeliveryStatus = delivery_status;
  }, [delivery_status]);
  useEffect(() => {
    filterStatus = payment_status;
  }, [payment_status]);
  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterPayment.map((obj) => {
      tempArr.push(obj);
    });
    filterDeliveryMode.map((obj) => {
      tempArr.push(obj);
    });
    filterDeliveryStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });

    setUpdateChipData(tempArr);
  }

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    }
    if (chipToDelete.type === "payment_mode") {
      setpayment_mode(
        payment_mode.filter((item) => item.id !== chipToDelete.id)
      );
      filterPayment = payment_mode.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "delivery_mode") {
      setDelivery_mode(
        delivery_mode.filter((item) => item.id !== chipToDelete.id)
      );
      filterDeliveryMode = delivery_mode.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "delivery_status") {
      setDelivery_status(
        delivery_status.filter((item) => item.id !== chipToDelete.id)
      );
      filterDeliveryStatus = delivery_status.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "payment_status") {
      setpayment_status(
        payment_status.filter((item) => item.id !== chipToDelete.id)
      );
      filterStatus = payment_status.filter(
        (item) => item.id !== chipToDelete.id
      );
    }
    loadChipdata();
  };
  const handleClear = (name, event) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      payment_mode: false,
      payment_status: false,
      delivery_mode: false,
      delivery_status: false,
    });
    // updateStateData();
    if (name === "payment_mode") {
      setpayment_mode([]);
      filterPayment = [];
    } else if (name === "delivery_mode") {
      setDelivery_mode([]);
      filterDeliveryMode = [];
    } else if (name === "delivery_status") {
      setDelivery_status([]);
      filterDeliveryStatus = [];
    } else if (name === "payment_status") {
      setpayment_status([]);
      filterStatus = [];
    }
  };
  const uniqueDeliveryStatys = Array.from(
    new Map(
      updateListData?.map((item) => [item.delivery_status, item])
    ).values()
  );
  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Order ID",
      // "Number of Books",
      "Date & Time",
      "Amount Paid",
      // "Payment Mode",
      "Payment Status",
      "Delivery Mode",
      "Deliver Status",
    ];
    const rows = csvData.map((item, index) => [
      // index + 1,
      item.purchase_id ?? "-",
      // item.item_count ?? "-",
      item.purchase_date ?? "-",
      item.amount_paid ?? "-",
      // item.payment_mode ?? "-",
      item.transaction_status ?? "-",
      item.shipping_type ?? "-",
      item.delivery_status_name ?? "-",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Books Payment Data",
          headers,
          rows,
          filename: "BooksPayment.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Order ID", key: "purchase_id" },
    { label: "Number of Books", key: "item_count" },
    { label: "Date & Time", key: "purchase_date" },
    { label: "Amount Paid", key: "amount_paid" },
    { label: "Payment Mode", key: "payment_mode" },
    { label: "Payment Status", key: "transaction_status" },
    { label: "Delivery Mode", key: "shipping_type" },
    { label: "Delivery Status", key: "delivery_status_name" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 3
          ? "row tab-content mt-4"
          : "row tab-content mt-4 hide "
      }
      id="ex2-content"
    >
      <div
        className={`global_container ${
          props.activeTab === 3
            ? "tab-pane fade show active col-md-12"
            : "tab-pane fade col-md-12"
        }`}
      >
        <div className="row mx-0">
          <div className="col-lg-6 col-md-3 col-sm-12 mb-3 col-xs-12 px-0">
            <div class={ListInfo.searchInputSec}>
              <input
                className={`${ListInfo.searchInput} w-100`}
                type="text"
                placeholder="Search by Order ID"
                name="SearchInput"
                onKeyDown={handleSearch}
                ref={txtBSearch} //new
              />
              <Search
                onClick={handleSearchFocus}
                className={`${ListInfo.ListsearchIcon}`}
              />
            </div>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"BooksPayment.csv"}
                  csvName="  Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
            </ul>
          </div>
        </div>
        {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData
                  .filter((kl) => kl.name !== "ActiveTab")
                  .map((data, index) => {
                    let icon;
                    let key = "" + data.name;
                    return (
                      <ListItem key={index}>
                        <Chip
                          icon={icon}
                          label={key}
                          onDelete={handleDelete(data, index)}
                        />
                      </ListItem>
                    );
                  })}

                <ListItem className="clearAll_list">
                  <a
                    className={"allclear clearAll_listItem"}
                    href="javascript:void(0)"
                    onClick={handleAllClear}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className="row mx-0">
          <div
            className={`col-md-12 ${ListInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
          >
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  <th id="th" className={ListInfo.tableThPadding}>
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export
                    </span>
                  </th>
                  <th className={ListInfo.tableThPadding} id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "purchase_id")}
                    >
                      Order ID
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "purchase_id")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  <th className={ListInfo.tableThPadding} id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "item_count")}
                    >
                      Number of Books
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "item_count")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  <th className={ListInfo.tableThPadding} id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "purchase_date")}
                    >
                      Date & Time
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "purchase_date")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  <th className={ListInfo.tableThPadding} id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "amount_paid")}
                    >
                      Amount Paid
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "amount_paid")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  <th
                    className={ListInfo.tableThPadding}
                    id="th"
                    ref={filterRef_payment_mode}
                  >
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "payment_mode")}
                    >
                      Payment Mode
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "payment_mode")}
                    >
                      import_export{" "}
                    </span>

                    <span
                      className={`textHead_th align-middle material-icons ${
                        payment_mode.length > 0 || isOpen.payment_mode
                          ? ListInfo.active_icons_book
                          : ""
                      } `} // Change here
                      onClick={(e) => handleFilter(e, "payment_mode")}
                    >
                      filter_list
                    </span>
                    {isOpen.payment_mode && (
                      <>
                        <div className="filterBoxs_testlist mt-3">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Online"}
                                  value={"1"}
                                  checked={payment_mode.some((element) => {
                                    if (element.id == "1") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Online"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "payment_mode",
                                      "payment_mode"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={"Online"}
                                >
                                  Online
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Cash"}
                                  value={"0"}
                                  checked={payment_mode.some((element) => {
                                    if (element.id == "0") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Cash"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "payment_mode",
                                      "payment_mode"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={"Cash"}
                                >
                                  Cash
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"QR Cash"}
                                  value={"2"}
                                  checked={payment_mode.some((element) => {
                                    if (element.id == "2") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"QR Cash"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "payment_mode",
                                      "payment_mode"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={"QR Cash"}
                                >
                                  QR Cash
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Free"}
                                  value={"3"}
                                  checked={payment_mode.some((element) => {
                                    if (element.id == "3") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Free"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "payment_mode",
                                      "payment_mode"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={"Free"}
                                >
                                  Free
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("payment_mode")}
                                  className="secondaryButton "
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    payment_mode.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("payment_mode")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  <th
                    className={ListInfo.tableThPadding}
                    id="th"
                    ref={filterRef_payment_status}
                  >
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "transaction_status")}
                    >
                      Payment Status
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "transaction_status")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        payment_status.length > 0 || isOpen.payment_status
                          ? ListInfo.active_icons_book
                          : ""
                      } `} // Change here
                      onClick={(e) => handleFilter(e, "payment_status")}
                    >
                      filter_list
                    </span>
                    {isOpen.payment_status && (
                      <>
                        <div className="filterBoxs_testlist mt-3">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Payment Pending"}
                                  value={"0"}
                                  checked={payment_status.some((element) => {
                                    if (element.id == "0") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Payment Pending"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "payment_status",
                                      "payment_status"
                                    )
                                  }
                                />
                                <label
                                  className={`filterChipText ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusPink}`}
                                  htmlFor={"Payment Pending"}
                                >
                                  Payment Pending
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"Completed"}
                                  value={"1"}
                                  checked={payment_status.some((element) => {
                                    if (element.id == "1") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"Completed"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "payment_status",
                                      "payment_status"
                                    )
                                  }
                                />
                                <label
                                  className={` filterChipText ${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusGreen}`}
                                  htmlFor={"Completed"}
                                >
                                  Completed
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("payment_status")}
                                  className="secondaryButton "
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    payment_status.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("payment_status")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  <th
                    className={ListInfo.tableThPadding}
                    id="th"
                    ref={filterRef_delivery_mode}
                  >
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "shipping_type")}
                    >
                      Delivery Mode
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "shipping_type")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        delivery_mode.length > 0 || isOpen.delivery_mode
                          ? ListInfo.active_icons_book
                          : ""
                      } `} // Change here
                      onClick={(e) => handleFilter(e, "delivery_mode")}
                    >
                      filter_list
                    </span>
                    {isOpen.delivery_mode && (
                      <>
                        <div className="filterBoxs_testlist mt-3">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={" Courier Delivery"}
                                  value={"1"}
                                  checked={delivery_mode.some((element) => {
                                    if (element.id == "1") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={" Courier Delivery"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "delivery_mode",
                                      "delivery_mode"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={" Courier Delivery"}
                                >
                                  Courier Delivery
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={"  Branch Pickup"}
                                  value={"0"}
                                  checked={delivery_mode.some((element) => {
                                    if (element.id == "0") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  id={"  Branch Pickup"}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "delivery_mode",
                                      "delivery_mode"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={"  Branch Pickup"}
                                >
                                  Branch Pickup
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("delivery_mode")}
                                  className="secondaryButton "
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    delivery_mode.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("delivery_mode")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  {/* Delivery status */}
                  <th
                    className={ListInfo.tableThPadding}
                    id="th"
                    ref={filterRef_delivery_status}
                  >
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "delivery_status")}
                    >
                      Delivery Status
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "delivery_status")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        delivery_status.length > 0 || isOpen.delivery_status
                          ? ListInfo.active_icons_book
                          : ""
                      } `} // Change here
                      onClick={(e) => handleFilter(e, "delivery_status")}
                    >
                      filter_list
                    </span>
                    {isOpen.delivery_status && (
                      <div className="filterBoxs_testlist">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {uniqueDeliveryStatys?.map((el) => (
                              <li
                                className={`filterListData
                                                    }`}
                              >
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.delivery_status_name}
                                  value={el.delivery_status}
                                  id={el.delivery_status_name}
                                  checked={delivery_status.some((element) => {
                                    if (element.id == el.delivery_status) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "delivery_status",
                                      "delivery_status"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.delivery_status_name}
                                >
                                  {el.delivery_status_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("delivery_status")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() =>
                                  handleApplyFilter("delivery_status")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  <th className={ListInfo.tableThPadding} id="th">
                    {" "}
                    <span className="text_th">Action</span>{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData.length === 0 ? (
                  <tr>
                    <td colspan="10" style={{ textAlign: "center" }}>
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData.map((course, index) => (
                    <tr key={index}>
                      <td id="td">
                        {course.serialNumber ? course.serialNumber : "_"}
                      </td>
                      <td id="td">
                        {course.purchase_id ? course.purchase_id : "_"}
                      </td>
                      <td id="td">
                        {course.item_count ? course.item_count : "_"}
                      </td>
                      <td id="td">
                        {" "}
                        {course.purchase_date
                          ? moment(course.purchase_date).utc().format("DD/MM/YYYY hh:mm:ss a")
                          : "_"}
                      </td>
                      <td id="td">
                        {course.amount_paid ? course.amount_paid : "0"}
                      </td>
                      <td id="td">
                        {course.payment_mode === 1
                          ? "Online"
                          : course.payment_mode === 2
                          ? "QR Cash"
                          : course.payment_mode === 3
                          ? "Free"
                          : "Cash"}{" "}
                      </td>
                      <td id="td">
                        {course.transaction_status == 4 ? (
                          <span
                            className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusGreen}`}
                          >
                            Completed
                          </span>
                        ) : (
                          <span
                            className={`${ListInfo.deliveryStatus} ${ListInfo.deliveryStatusPink}`}
                          >
                            Payment Pending
                          </span>
                        )}
                      </td>
                      <td id="td">
                        {course.shipping_type == 1
                          ? "Courier Delivery"
                          : "Branch Pickup"}
                      </td>

                      <td id="td">
                        {course.delivery_status_name
                          ? course.delivery_status_name
                          : "_"}
                      </td>
                      <td id="td">
                        <img
                          src={ViewIcon}
                          onClick={() =>
                            handleNavPage(
                              course.id,
                              course.transaction_order_id
                            )
                          }
                          className={ListInfo.cursor_pointer}
                          alt="view icon"
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData && updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData && updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              updateListData && updateListData?.length > 0
                ? updateListData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            prevButton={`${ListInfo.prev_buttonViewAllbook} ${ListInfo.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages}
          />
        </div>
      </div>
    </div>
  );
}

export default BookPurchase;
